import React, { useState } from 'react';
import styles from './ThirdPartyInfo.css';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AddNewSignerPopup from './AddNewSignerPopUp';
import { countryInfo } from '../Constants/constants';
import {FormattedMessage} from 'react-intl';

export default function AddNewSigner({ getOnDemandSigners, countryCode }) {
    const [showPopup, setShowPopup] = useState(false);
    function addSigner() {
        setShowPopup(!showPopup);
    }

    const getAddedOdSigener = (odSigner) => {
        getOnDemandSigners(odSigner);
    }

    return (
        <div className={styles.addNewSignerMain}>
            <div className={styles.addNewSigner} onClick={() => addSigner()}>
                <div >
                    <AccountCircleIcon fontSize="large" />
                    <p>
                        <FormattedMessage id={'labels.ADD_SIGNER'} />
                    </p>
                </div>
            </div>
            <AddNewSignerPopup getOnDemandSigners={getAddedOdSigener}
                odContactNumber={`${countryInfo[countryCode].getIsdCode()} `}
                odEmail=""
                odName=""
                setShowPopup={setShowPopup}
                showPopup={showPopup}
            />
        </div>
    )

}
